module.exports = __webpack_public_path__ + "img/tw.14f54b5d.svg";